export const BASE_URL = "https://www.pre-onboarding-selection-task.shop";
